import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

/**
 * errorElement for the router. React Router catches render/loader errors
 * itself and swaps in this element, so it must show something - an empty
 * element here is exactly what produces a blank white screen.
 */
const RouteErrorFallback = () => {
    const error = useRouteError();

    console.error('Route error:', error);

    const message = isRouteErrorResponse(error)
        ? `${error.status} ${error.statusText}`
        : error instanceof Error
            ? error.message
            : 'An unexpected error occurred';

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
                <h3 className="text-lg font-medium text-gray-900">Something went wrong</h3>
                <p className="mt-2 text-sm text-gray-500 break-words">{message}</p>
                <div className="mt-6 flex gap-3">
                    <button
                        onClick={() => { window.location.href = '/'; }}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    >
                        Go to home
                    </button>
                    <button
                        onClick={() => window.location.reload()}
                        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                    >
                        Reload page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RouteErrorFallback;
